import React from 'react'
import { MyImage } from '../ui/MyImage'
import styled from 'styled-components'
import { Container } from '../ui/Container'

const StyledPageBanner = styled.div`
  height: 300px;
  position: relative;
  margin-bottom: 128px;
  margin-top: -40px;
`

const StyledPageBannerContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  font-size: 48px;
  line-height: 56px;
  color: ${props => props.theme.light3};
`

export const PageBanner: React.FC<{
  bg: string
  style?: React.CSSProperties
}> = ({ bg, children, style }) => {
  return (
    <StyledPageBanner style={style}>
      <MyImage style={{ height: 300 }} lazy={false} src={bg} />
      <StyledPageBannerContent>
        <Container>{children}</Container>
      </StyledPageBannerContent>
    </StyledPageBanner>
  )
}
